import { CheckCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { Drawer, List, Space, Tag, Typography } from "antd";
import { useHandleSubmitApi } from "hook";
import { IDetailChangeRevisionOutputModel, IPostRevisionOutputModel } from "interfaces";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { PostServices } from "services";
import HistoryTablePostForm from "./HistoryTablePostForm.presenter";
const Diff = require("diff");

export interface IHistoryPostFormProps {
  onClose: () => void;
  id: string | null;
}

export default function HistoryPostForm(props: IHistoryPostFormProps) {
  const { Text } = Typography;
  const [data, setData] = useState<IPostRevisionOutputModel[]>([]);
  const [dataRevision, setDataRevision] = useState<IDetailChangeRevisionOutputModel[]>([]);
  const [revisionId, setVisionId] = useState<string | null>(null);

  useEffect(() => {
    if (!props.id) return;
    getListHistory(props.id);
  }, [props.id]);

  useEffect(() => {
    if (!revisionId || !props.id) return;
    getDiffRevision(revisionId);
  }, [revisionId]);

  const [getListHistory, loadingGetHistory] = useHandleSubmitApi(async (postId: string) => {
    const dataRes = await PostServices.getListPostRevision(postId);
    if (dataRes) {
      if (dataRes.data && dataRes.data.length) {
        setData(_.orderBy(dataRes.data, ["version"], ["desc"]));
      }
    }
  });

  const [getDiffRevision, loadingDiffRevision] = useHandleSubmitApi(async (revisionId: string) => {
    const dataRes = await PostServices.getDiffRevisionPost(revisionId);
    if (dataRes) {
      if (!!dataRes.data) {
        setDataRevision(dataRes.data);
      }
    }
  });

  return (
    <>
      <HistoryTablePostForm
        data={dataRevision}
        onClose={() => {
          setVisionId(null);
          setDataRevision([]);
        }}
      />

      <Drawer title="Lịch sử thay đổi" onClose={props.onClose} open={!!props.id}>
        <List
          dataSource={data}
          loading={loadingGetHistory}
          renderItem={(revision) => (
            <List.Item
              key={revision.id}
              onClick={() => {
                console.log(revision.id);
                setVisionId(revision.id);
              }}
              style={{ cursor: "pointer" }}
            >
              <List.Item.Meta
                title={
                  <div className="d-flex items-center justify-space-between">
                    <span className="mr_1">{`Version ${revision.version}`}</span>
                    {revision.version === 1 ? (
                      <Tag icon={<CheckCircleOutlined />} color="success">
                        Tạo mới
                      </Tag>
                    ) : (
                      <Tag icon={<SyncOutlined spin />} color="processing">
                        Cập nhật
                      </Tag>
                    )}
                  </div>
                }
                description={
                  <Space direction="vertical">
                    <Text>{moment(revision.revisedAt).format("DD/MM/YYYY HH:mm:ss")}</Text>
                    <Text>
                      Cập nhật: <b>{revision.changeBy?.lastName + " " + revision.changeBy.firstName}</b>
                    </Text>
                  </Space>
                }
              />
            </List.Item>
          )}
        />
      </Drawer>
    </>
  );
}
